import { createContext, useCallback, useContext, useMemo, useReducer } from 'react';
import { loggingMiddleware } from '../../utils/store';
import { appActions } from '../app/context';
import { associateObjects, disassociateObject, getAssociatedObjects, getAssociationSectionList } from './functions';
import { AssociationsPropsContext } from './PropsContext';
import { ASSOCIATE_OBJECTS, DISASSOCIATE_OBJECT, GET_ASSOCIATED_OBJECTS, GET_ASSOCIATION_SECTION_LIST, initialState, reducer, SET_CREATED_OBJECT, SET_CRM_OBJECT_TYPE, UPDATE_ACCOSIATED_OBJECT } from './reducer';
import { jsx as _jsx } from "react/jsx-runtime";
export const AssociationsContext = /*#__PURE__*/createContext(initialState);
export const AssociationsContextProvider = ({
  children
}) => {
  const [associations, dispatchCTX] = useReducer(loggingMiddleware('associations')(reducer), initialState);
  const {
    apiWrapper,
    usageTracker
  } = useContext(AssociationsPropsContext);
  const asyncFuncArg = useMemo(() => ({
    dispatch: dispatchCTX,
    apiWrapper,
    postponeWithAppLoader: appActions.postponeWithAppLoader,
    usageTracker
  }), [apiWrapper, usageTracker]);
  const dispatch = useCallback(action => {
    switch (action.type) {
      case GET_ASSOCIATED_OBJECTS:
        getAssociatedObjects(asyncFuncArg, action.payload);
        break;
      case DISASSOCIATE_OBJECT:
        disassociateObject(asyncFuncArg, action.payload);
        break;
      case ASSOCIATE_OBJECTS:
        associateObjects(asyncFuncArg, action.payload);
        break;
      case GET_ASSOCIATION_SECTION_LIST:
        getAssociationSectionList(asyncFuncArg, action.payload);
        break;
      default:
        {
          dispatchCTX(action);
        }
    }
  }, [asyncFuncArg]);
  const actions = useMemo(() => ({
    getAssociationSectionList: data => dispatch({
      type: GET_ASSOCIATION_SECTION_LIST,
      payload: data
    }),
    associateObjects: data => dispatch({
      type: ASSOCIATE_OBJECTS,
      payload: data
    }),
    disassociateObject: data => dispatch({
      type: DISASSOCIATE_OBJECT,
      payload: data
    }),
    setCrmObjectType: value => dispatch({
      type: SET_CRM_OBJECT_TYPE,
      payload: value
    }),
    getAssociatedObjects: data => dispatch({
      type: GET_ASSOCIATED_OBJECTS,
      payload: data
    }),
    setCreatedObject: data => dispatch({
      type: SET_CREATED_OBJECT,
      payload: data
    }),
    updateAccosiatedObject: data => dispatch({
      type: UPDATE_ACCOSIATED_OBJECT,
      payload: data
    })
  }),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const state = useMemo(() => Object.assign({}, associations, {
    dispatch,
    associationsActions: actions
  }), [associations, dispatch, actions]);
  return /*#__PURE__*/_jsx(AssociationsContext.Provider, {
    value: state,
    children: children
  });
};